import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentProjectListPageContext,
  ComponentProjectListPageInitialState,
} from ".";

export const ComponentProjectListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    ComponentProjectListPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentProjectListPageContext.Provider value={context}>
      {children}
    </ComponentProjectListPageContext.Provider>
  );
};
